import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_completed_receiving_tasks_by_orderId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, OrderId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
